import { render, staticRenderFns } from "./elevator-detail.vue?vue&type=template&id=52ad1de2"
import script from "./elevator-detail.vue?vue&type=script&lang=js"
export * from "./elevator-detail.vue?vue&type=script&lang=js"
import style0 from "./elevator-detail.vue?vue&type=style&index=0&id=52ad1de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports